import React from "react";
import { useApp } from "../context/AppContext";
import SubcontractorPortal from "./SubcontractorPortal";
import SubAccountSwitcher from "./SubAccountSwitcher";
import SubcontractorSchedule from "../components/SubcontractorSchedule";

/** 工作台共用月历：经理以本人身份派工，分包商看本人任务；原有代操作入口维持原权限。 */
export default function PortalEntry() {
  const { user, featVis, permOf } = useApp();
  if (user?.role === "subcontractor") return <SubcontractorPortal />;
  return <div className="space-y-6">
    {permOf("/board::schedule-manage") === true && <SubcontractorSchedule key={user.username} />}
    {featVis("/portal", ["admin", "ceo", "eng_manager"].includes(user?.baseRole || user?.role)) && <SubAccountSwitcher />}
  </div>;
}
